import React, { forwardRef } from 'react';

import { withEventScope } from '@repo/event-processor';

import { useBackgroundReplacerStore } from 'stores/backgroundReplacerStore/backgroundReplacerStore';

import ImageTile from './ImageTile';
import { GalleryWrapper } from './styles';
import { GalleryProps } from './types';

const Gallery = forwardRef<HTMLDivElement, GalleryProps>(
  ({ items, onItemClick }, ref) => {
    const { presetLabels } = useBackgroundReplacerStore((store) => {
      return { presetLabels: store.presetLabels };
    });

    return (
      <GalleryWrapper>
        {items.map((image, i) => {
          if (image.sceneId) {
            image.label = presetLabels[image.sceneId];
          }

          if (i === 0) {
            return (
              <div key={image.id} ref={ref}>
                <ImageTile image={image} onClick={(): void => onItemClick(i)} />
              </div>
            );
          } else {
            return (
              <ImageTile
                key={image.id}
                image={image}
                onClick={(): void => onItemClick(i)}
              />
            );
          }
        })}
      </GalleryWrapper>
    );
  }
);

Gallery.displayName = 'Gallery';

export default withEventScope(Gallery, { module: 'gallery' });
